import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    authenticate: false,
    token: null,
    isUnauthorizedToAccessApp: false
};
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setIsUnauthorizedToAccessApp: (state, action) => {
            state.isUnauthorizedToAccessApp = action.payload;
        },
        setAuthenticate: (state, action) => {
            state.authenticate = action.payload;
        }
    },
});
// Action creators are generated for each case reducer function
const { setToken, setIsUnauthorizedToAccessApp, setAuthenticate } = authSlice.actions;
const selectIsUnauthorizedToAccessApp = (state) => state.auth.isUnauthorizedToAccessApp;
var authReducer = authSlice.reducer;

export { authSlice, authReducer as default, selectIsUnauthorizedToAccessApp, setAuthenticate, setIsUnauthorizedToAccessApp, setToken };
//# sourceMappingURL=authSlice.js.map
